module.exports = __webpack_public_path__ + "static/img/MyUseCase.cb825a96.png";